import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { DownlineHeader, getDecodedToken } from "../Utils/Constant";

const RootRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = getDecodedToken();
  useEffect(() => {
    if (location.pathname !== "/") return;

    const downlineList = DownlineHeader(user?.userType);
    const firstLayer = downlineList?.[0];

    if (firstLayer) {
      navigate(`/users/${firstLayer.layer}`, { replace: true });
    }
  }, [user, location.pathname]);

  return null; // or a loader/spinner while redirecting
};
export default RootRedirect;
